import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  item: {
    marginTop: '10px',
  },
  areaQuesitos: {
    height: '500px',
    overflow: 'auto',
  },
}))

export default useStyles
